var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMrf(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 308,
    height: 104,
    viewBox: "0 0 308 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_20_1315)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M191.792 34.2099V42.7893H198.694V61.2088H185.927L182.371 57.2328C182.371 57.2328 190.496 54.0826 190.116 44.8823C189.697 34.8378 176.301 34.2099 176.301 34.2099H112.463L106.813 46.5567L101.161 34H70.394V43.2091H80.2317L73.1149 60.1617H66V69.7894H93.4175V60.5816H88.6036L92.7896 51.3712L98.4406 69.5802H111.836L119.161 51.3712L123.137 60.789H117.277V69.7894H162.697V60.9995H156.625V57.0235H163.116L177.139 70H218.997V61.2088H211.461V57.6508H226.952V48.6522H211.461V42.7893H231.767V50.1147H243.275V34.418L191.792 34.2099ZM143.229 60.5816H138.416L131.091 43.4184H143.229V60.5816ZM173.582 46.9765H156.625V43.8345L173.582 43.6284C173.582 43.6284 175.255 43.4184 175.255 45.091C175.255 46.7672 173.582 46.9765 173.582 46.9765Z",
    fill: "#EF4023"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_20_1315"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 177.275,
    height: 36,
    fill: "white",
    transform: "translate(66 34)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMrf);
export default __webpack_public_path__ + "static/media/mrf.393cb07ea5a7138e26840bbe62bd6fe9.svg";
export { ForwardRef as ReactComponent };